import React, { Fragment, useEffect, useState, useContext } from "react";
import { useSignIn, useSignOut } from "react-auth-kit";
import { useNavigate, useParams } from "react-router-dom";
import {
  createClientIdQueryString,
  sendApiRequest,
} from "../../services/Base/base-service";
import { notifyUser } from "../../services/helpers";

import SubNavigation from "../../components/Header/SubNavigation";
import UserContext from "../../store/user-context";
import ClientDocumentPhrasesConfigModal from "../../components/Modals/ClientDocumentPhrasesConfigModal";
import ConfirmModal from "../../components/Modals/ConfirmModal";
import ClientDocumentPhrasesConfigurationTable from "../../components/Tables/ClientDocumentPhrasesConfigurationTable";
import { Alert, NotificationManager, Section, Spinner } from "design-react-kit";
import Footer from "../../components/Footer";

const ClientDocumentPhrasesConfiguration = () => {
  const [phrases, setPhrases] = useState(null);
  const [phrasesNumber, setPhrasesNumber] = useState(null);
  const [error, setError] = useState(null);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [phrasesModalOpen, setPhrasesModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [editablePhrase, setEditablePhrase] = useState(false);

  const params = useParams();
  const clientName = params?.client;
  const clientId = params?.clientId;
  const documentType = params?.document;
  const clientDocumentRuleId = params?.clientDocumentRuleId;

  const userContext = useContext(UserContext);

  const signIn = useSignIn();
  const signOut = useSignOut();
  const navigate = useNavigate();

  useEffect(() => {
    getClientDocumentFieldConfigs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getClientDocumentFieldConfigs = () => {
    setIsLoading(true);
    sendApiRequest(
      `ClientConfiguration/GetClientDocumentFieldConfigs?clientDocumentRuleId=${clientDocumentRuleId}`,
      "GET",
      true,
      null,
      signIn,
      signOut,
      navigate,
      null,
      userContext
    ).then((response) => {
      if (response !== undefined) {
        if (response.errors !== null) {
          setError(response.errors);
          setIsLoading(false);
        } else {
          setPhrases(response.data.clientDocumentFieldConfigs);
          setIsLoading(false);
        }
      }
    });
  };

  useEffect(() => {
    sendApiRequest(
      "ClientConfiguration/GetKeyPhrases",
      "GET",
      true,
      { clientId },
      signIn,
      signOut,
      navigate,
      createClientIdQueryString,
      userContext
    ).then((response) => {
      if (response !== undefined) {
        if (response.errors !== null) {
          setError(response.errors);
          setIsLoading(false);
        } else {
          setPhrasesNumber(response.data.keyPhrases.length);
          setIsLoading(false);
        }
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const phrasesModalOpenHandler = (item) => {
    setPhrasesModalOpen(true);
    setEditablePhrase(item);
  };

  const phrasesModalCloseHandler = () => {
    setPhrasesModalOpen(false);
  };

  const confirmModalCloseHandler = () => {
    setConfirmModalOpen(false);
  };

  const confirmModalOpenHandler = (phrase) => {
    setEditablePhrase(phrase);
    setConfirmModalOpen(true);
    setTimeout(() => {
      document.querySelector(".modal-email").textContent =
        phrase.notificationTargetFieldLabel;
    }, 600);
  };

  return (
    <Fragment>
      <SubNavigation
        page="clientDocumentPhrasesConfiguration"
        openModalHandler={phrasesModalOpenHandler}
        phrasesNumber={phrasesNumber}
      />
      <Section>
        {error !== null && error.length !== undefined && (
          <Alert color="danger" className="mx-auto">
            {error.map((item) => (
              <p key={item}>{item}</p>
            ))}
          </Alert>
        )}
        {isLoading && (
          <p
            style={{
              height: "50px",
              position: "relative",
              marginBottom: "3rem",
            }}
          >
            <Spinner double active />
          </p>
        )}
        {error === null && !isLoading && (
          <ClientDocumentPhrasesConfigurationTable
            items={phrases}
            columns={[
              {
                name: "Nome del campo",
                type: "string",
                sortable: true,
                value: "notificationTargetFieldLabel",
              },
              {
                name: "Frase identificativa/soglia iniziale",
                type: "string",
                sortable: false,
                value: "",
              },
              {
                name: "Frase soglia finale",
                type: "string",
                sortable: false,
                value: "",
              },
              {
                name: "Regola di combinazione",
                type: "string",
                sortable: false,
                value: "",
              },
              {
                name: "Azioni",
                type: "",
                sortable: false,
                value: "",
              },
            ]}
            phrasesModalOpenHandler={phrasesModalOpenHandler}
            confirmModalOpenHandler={confirmModalOpenHandler}
            getClientDocumentFieldConfigs={getClientDocumentFieldConfigs}
          />
        )}
      </Section>
      <ClientDocumentPhrasesConfigModal
        modalOpen={phrasesModalOpen}
        modalCloseHandler={phrasesModalCloseHandler}
        editablePhrase={editablePhrase}
        clientName={clientName}
        documentType={documentType}
        notifyUser={notifyUser}
        setPhrases={setPhrases}
        setPhrasesNumber={setPhrasesNumber}
      />
      <ConfirmModal
        confirmModalOpen={confirmModalOpen}
        confirmModalCloseHandler={confirmModalCloseHandler}
        notifyUser={notifyUser}
        method={"deleteClientDocumentFieldConfigHandler"}
        text={"Stai per eliminare l'frase"}
        clientDocumentRuleId={editablePhrase?.clientDocumentRuleId}
        notificationTargetFieldId={editablePhrase?.notificationTargetFieldId}
        setPhrases={setPhrases}
        setPhrasesNumber={setPhrasesNumber}
      />
      <div>
        <NotificationManager
          containerId="esempio-avanzato"
          fix="right"
          closeOnClick={true}
          state="success"
          duration={30000}
        />
      </div>
      <Footer />
    </Fragment>
  );
};

export default ClientDocumentPhrasesConfiguration;
